export const FILTER_PROPS = [
  { label: "Артем", value: "children" },
  { label: "ШуСу", value: "adults" },
  { label: "Для всіх", value: "all" },
];

export const FILTER_PROPS_MAP = {
  artem: "Артем",
  shu: "Шу",
  su: "Су",
  all: "Для всіх",
};
